import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ChatPageUI from './ChatPageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class ChatMessageListSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            userMessageList: null,
            selectedRowId: null,
            deleteSubmitted: false,
            deleteSuccessMsg: null,
            deleteErrorList: null,
        }
    }

    render() {
        return (
            <ChatPageUI
                context={this.props.context}
                account={this.state.account}
                errorList={this.state.errorList}
                userMessageList={this.state.userMessageList}
                onRefreshClick={this.onRefreshClick}
                selectedRowId={this.state.selectedRowId}
                deleteSubmitted={this.state.deleteSubmitted}
                deleteSuccessMsg={this.state.deleteSuccessMsg}
                deleteErrorList={this.state.deleteErrorList}
                onDeleteClick={this.onDeleteClick}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getAccounts(context)
        this.getChatMessages(context)
    }

    getAccounts(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}`,
            cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
            callback: this.getAccountsCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getAccountsCallback = (response) => {
        this.setState({ account: response.account })
    }

    getChatMessages(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}/chatMessages`,
            cacheKey: CacheKeys.ChatMessages(this.props.match.params.accountId),
            callback: this.getChatMessagesCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getChatMessagesCallback = (response) => {
        this.setState({ userMessageList: response.userMessageList, errorList: response.errorList })
    }

    onDeleteClick = (event) => {
        if (this.state.deleteSubmitted)
            return

        let rowId = event.target.getAttribute('data-row-id')
        this.setState({
            deleteSubmitted: true,
            deleteErrorList: [],
            selectedRowId: rowId
        })

        RestApiUtils.delete(this.props.context,
            `/api/su/messageLists/${rowId}`,
            this.onDeleteClickCallback, {}
        )
    }

    onDeleteClickCallback = (response) => {
        let errorList = []
        if (response.errorList.length) {
            response.errorList.forEach(error => {
                errorList.push(error.message)
            })
        }

        this.setState({
            deleteSuccessMsg: response.success,
            deleteErrorList: errorList,
            deleteSubmitted: false,
        })

        if (errorList.length === 0) {
            setTimeout(() => {
                this.setState({ deleteSuccessMsg: null, deleteErrorList: [] })
                this.onRefreshClick('noBusy')
            }, 2000)
        }
    }

    onRefreshClick = (noBusy) => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.ChatMessages(this.props.match.params.accountId))
        if (noBusy === 'noBusy')
            this.getChatMessages(context)
        else
            this.setState({
                errorList: null,
                userMessageList: null
            }, this.getChatMessages(context)
            )
    }

}

export default withRouter(ChatMessageListSF)
